import React from "react"
import { AdminPasswordModal } from "components"

type Props = {
  open: boolean
  onVerify: (password: string) => void
  onCancel: () => void
}

/**
 * Thin wrapper around the shared `AdminPasswordModal` — preserves the
 * `onVerify` callback name the native-games-control consumer was already
 * using while the actual popup (autofocus, Enter-to-submit, single source
 * of truth) lives in `components/adminPasswordModal`.
 */
export const AdminUnlockModal: React.FC<Props> = ({ open, onVerify, onCancel }) => (
  <AdminPasswordModal
    open={open}
    title="Admin Access Required"
    description="Enter the admin password to unlock adding, editing, or removing games, as well as editing game tasks."
    submitLabel="Unlock"
    onSubmit={onVerify}
    onCancel={onCancel}
  />
)
